import { connect, ConnectedProps } from 'react-redux';
import {
  hasAggregation,
  hasAggregationSelected,
} from './searchFiltersBarUtils';
import { StateType } from '../../../state/reducers';
import {
  buildAggregationFilters,
  buildDateFilter,
} from '../search-snippets/aside/filter-box/filterBoxUtils';

const mapState = ({ aggregations, queryParams }: StateType) => ({
  shouldDisplayPublisher: hasAggregation(aggregations, 'publisher'),
  hasPublisherSelected: hasAggregationSelected(queryParams, 'publisher'),
  publisherCount: buildAggregationFilters(
    queryParams.aggregationsPaths,
    'publisher',
  ).length,
  shouldDisplayCommentaryAccess: hasAggregation(
    aggregations,
    'commentaryAccess',
  ),
  hasCommentaryAccessSelected: hasAggregationSelected(
    queryParams,
    'commentaryAccess',
  ),
  commentaryAccessCount: buildAggregationFilters(
    queryParams.aggregationsPaths,
    'commentaryAccess',
  ).length,
  type: queryParams.type,
  query: queryParams.userQuery,
  hasDateSelected: !!queryParams.dates.from || !!queryParams.dates.to,
  dateLabel: queryParams.dates ? buildDateFilter(queryParams.dates) : null,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
